module.exports = __webpack_public_path__ + "img/34.bc4b695a.jpg";